export default __webpack_public_path__ + "locales/it/PeopleTranslations.json?hash=0f3c677a64effcb2aa15ea7e4d2f34e8";